import { FC, startTransition, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import ReactTooltip from "react-tooltip";
import { useToasts, FlexBox, BLangSwitcher, useBreakpoint, ButtonVariant, BrgButton } from '@brg/ui';
import { API, Endpoints, Tag } from '@brg/api';
import {
  TagsAvailableTitle,
  ModalContextSplitLine, TabletTitle,
  TagsSearchInput,
  TagsSearchInputWrapper,
  TagsSearchModalContainer,
  TagsSearchModalWrapper,
  TagsSearchResults,
  TagsSearchResultsContext,
  TagsSearchSelection,
  TagsSearchTitle,
  TagsSelectedTitle,
  SubmitButton,
  LangSelectHolder,
  TagsSearchResultsWrapper,
  TitleContainer,
} from './styles';
import { TagsSearchResultsItem } from './tagsSearchResultsItem';
import { BTag } from '../../../core/components';
import { bTag, LayoutConst, useModal } from '../../../core';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { EmptyText, EmptyTextWrapper } from './FoundTags';
import { debounceEvent } from 'shared/utils/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { TagsActions, TagsSelector } from 'shared/reducers/Tags';
import { ArrowTopRightIcon, SearchIcon } from 'shared/icons';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { getSearched, getUpdated } from './support/updateTag';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { filterChildrens } from './support/filterChildrens';
import { AppTester } from 'supporting';
import { SaveUserLang } from "../../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../../components/__ADDONS__/__LANG__/Slice";
import { setInitialChildrens } from './support/setInitialChildrens';
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { isRequired } from './support/isRequired';
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import CategoryList from "./CategoryList";
import { useGetAllTags } from 'shared/hooks/api/useGetAllTags';
import useQueryState from 'shared/hooks/useQueryState';
import { SimplePagination } from 'shared/components/pagination/SimplePagination';
import { extractTagChilds } from './support/extractTagChilds';
import { removeUndefined } from "../../helpers/removeUndefined";
import { CreateTagButton } from './components/CreateTagComponent/style';
import { CreateTagComponent } from './components/CreateTagComponent/CreateTagComponent';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import { useInitialCategories } from './support/useInitialCategoires';
import { SelectTagsModalProps } from './types';
import LangSwitcher from 'shared/components/LangSwitcher/LangSwitcher';

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isSearchResult?: boolean;
  isMoreButton?: boolean;
  isEmptyCategory?: boolean;
  level?: number;
  entityTypes?: string[];
  typeCategory?: string;
  isShowAll?: boolean;
}

export enum LOAD_TYPE {
  initial = 1,
  update = 2,
  tagSearch = 3,
  tagsSearchIntoCategory = 4,
  tagSearchIntoTag = 5,
  tagGlobalSearchIntoTag = 6,
  tagSearchGlobal = 7,
  tagsFetchMore = 8,
  tagsFetchMoreLarge = 9,
  tagsFetchMoreLargeChild = 10,
  test = 11,
  updateLang = 12
}

export const LABORATORY_PARAM = '?_lab';
export const APPROVED_HSEDESIGN_PARAM = '';
export const REQUIRED_TAG_ID = '390ea8c2329fc0bc9c389a1b0f1f6e4d';
export const EDUCATIONAL_CATEGORY_ID = 'c326e5a4bd0b02c9c338fe382ac1f9a8';
export const ALL_TAGS_LIMIT = 100;
/** Cap right-panel render — categories like cities/places have 1.5k–3k tags */
export const VISIBLE_CATEGORY_TAGS_LIMIT = 80;

const ClearSearchButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

const ClearSearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_19454_17501)">
      <path d="M7.9999 9.03564L1.72535 15.3102C1.47255 15.563 1.06065 15.5644 0.812094 15.3075C0.756406 15.2499 0.725178 15.2165 0.706523 15.1957C0.463197 14.925 0.4441 14.52 0.701494 14.2626L6.96417 7.9999L0.6896 1.72534C0.4368 1.47254 0.4368 1.06267 0.6896 0.809868L0.809867 0.689601C1.06267 0.4368 1.47254 0.4368 1.72534 0.689601L7.9999 6.96417L14.2745 0.689601C14.5273 0.4368 14.9371 0.4368 15.1899 0.689601L15.3102 0.809868C15.563 1.06267 15.563 1.47254 15.3102 1.72534L9.03564 7.9999L15.3102 14.2745C15.563 14.5273 15.5644 14.9392 15.3075 15.1877C15.2499 15.2434 15.2165 15.2746 15.1957 15.2933C14.925 15.5366 14.52 15.5557 14.2626 15.2983L7.9999 9.03564Z" fill="#909090"/>
    </g>
    <defs>
      <clipPath id="clip0_19454_17501">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);


export const SelectTagsModal: FC<SelectTagsModalProps> = (props) => {
  const {
    value, onChange,
    mode,
    ctx,
    isCompetencies,
    max,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    onClose,
    onAfterTagCreate,
    hideGlobalSearchBar,
    maxEducationalTags,
    ungroup,
    protectedTags = [],
    editableTags = [],
    requiredTags,
    isTagEditor,
    isMobileMenu,
    isTagAdminPage,
    isEdit,
    educational,
    isCreateLocation,
    global: globalProp,
    hasEduTags,
    saveOnClick = true,
    viewAllTags,
    ignoreHeader,
    maxTagsExceededMessageKey,
    allowCategorySelect,
    categoriesOnly,
  } = props;

  const [innerValue, setInnerValueFinal] = useState<Tag[]>(value ?? []);
  const [innerLocalValueRaw, setInnerLocalValue] = useState<Tag[]>([]);
  const location = useLocation();
  const valueRef = useRef<Tag[]>([]);
  const prevLangRef = useRef<string | null>(null);
  const tagSearchListRef = useRef<HTMLDivElement>(null);
  const activeTag = useRef<any>(null)
  const mainSearchRef = useRef<any>(null);
  /** Processed right-panel payload per category — skip fetch/regroup on revisit */
  const processedCategoryCacheRef = useRef<Map<string, any>>(new Map());
  const currentCategoryRef = useRef<string | null>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isEditProjectPage = location.pathname.startsWith('/edit');
  const isCreateLocationPage = location.pathname.startsWith('/createLocation');
  const isBrnd = AppTester.isBrnd();
  const isStartHSE = AppTester.isStartHSE();
  const [{ page }, setQueryState ] = useQueryState();

  const [hideMore, setHideMore] = useState(false);

  const isHSEdesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isIqMediia = AppTester.isIqMediiia();
  const isHseSpace = AppTester.isHseSpace();
  const isAKI = AppTester.isAKI();
  const isHseSpaceSubcontext = AppTester.isHSESpaceSegmants();
  const isFilmRoute = !!useRouteMatch('/film');
  const isMobile = useBreakpoint(LayoutConst.screen.s);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const theme = useTheme();
  const modal = useModal();
  const { t, i18n } = useTranslation();
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [foundCategories, setFoundCategories] = useState<any[]>([]);
  const [searchText, setSearchText] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [searchInitialParam, setInitialSearchParam] = useState<any>(null);
  const [currentCategory, setCurrentCategory] = useState<string | null>(null);
  const profile = useProfile()
  const isModer = !!profile && (bProfile.isModer(profile) || bProfile.isSuperModer(profile))
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor, editableTags?.length])

  const handlePageChange = (p: number ) => {
    setQueryState({ page: p })
    setTime(Date.now());
  }

  const isLinkMode = mode === 'link';

  const optionTagsFilter = useMemo(() => {
    const shouldApplyEducationFilter = isHseSpace 
      ? (isEdit && isHseSpace)
      : !isHseSpace;
    
    return {
      isModeEditing: isEdit || false,
      ...(isHseSpace && isTagsSearchPage ? {
        isEducation: false,
        hasEduTags: false,
      } : (shouldApplyEducationFilter && (isStartHSE && isTagsSearchPage ? {
        isEducation: true,
      } : educational !== undefined ? {
        isEducation: educational,
      } : {}))),
    ...(ctx  ? {
      entityTypes: ctx,
    } : {}),
    ...(isTagEditor && !isModer && editableTags ? {
      tagIds: editableTags || [],
    } : {}),
    ...(global ? {
      isHeaderIgnored: global,
    } : {}),
    ...(hasEduTags !== undefined && !isAKI && !(isStartHSE ||isHseSpace && isTagsSearchPage) ? {
      hasEduTags: hasEduTags,
    } : {}),
    ...(isBrnd && isEdit && ignoreHeader !== false ? {
      isHeaderIgnored: true,
    } : {}),
    };
  }, [isModer, isEdit, educational, isTagEditor, global, ctx, hasEduTags, isStartHSE, isTagsSearchPage, isHseSpace, isHseSpaceSubcontext, isAKI])

  useEffect(() => {
    if (
      searchText?.length && 
      isLinkMode && 
      prevLangRef.current && 
      prevLangRef.current !== i18n.language
    ) {
      setInitialSearchParam({ search: [ searchText ] })
    }
    prevLangRef.current = i18n.language
  } , [i18n.language, isLinkMode, searchText, prevLangRef.current])

  const initialTagsFilter = useMemo(() => ({
    ...optionTagsFilter,
    ...(isTagEditor ? { status: [0, 1] } : { status: [0] }),
    lang: i18n.language,
    ...(searchInitialParam ? searchInitialParam : {})
  }), [i18n.language, optionTagsFilter, searchInitialParam, isTagEditor])


  const appContext = isFilmRoute ? 'filmhsespace' : '';
  
  const initialCategoryList = useInitialCategories(optionTagsFilter);

  const finalCategoryList = useMemo(() => {

    return initialCategoryList
  } , [initialCategoryList])

  const initialAllTagsFilter = useMemo(() => ({
    status: [0],
    levels: [1],
    isHeaderIgnored: true,
    includeCount: true,
    limit: ALL_TAGS_LIMIT,
    page: page ? Number(page) : 1
  }), [ctx, i18n.language, page, isEditProjectPage])

  const [tagsFilter, setTagsFilterFinal] = useState<ITagsProps>(initialTagsFilter);

  const setTagsFilter = useCallback((filter: ITagsProps) => {
    setTagsFilterFinal({
      ...removeUndefined(filter)
    })
  }, [optionTagsFilter, requiredTags])

  const [loadType, setLoadType] = useState<number>(LOAD_TYPE.initial);
  const [time, setTime] = useState(Date.now());
  const [_, setIsOpenTag] = useState<boolean>(false); /** TODO: почистить и проверить компоненты, в которые пробрасывается сеттер  */

  const isViewAllTagsMode = useMemo(() => {
    return viewAllTags && loadType !== LOAD_TYPE.tagSearchGlobal
  } , [viewAllTags, loadType])

  const requestsDisabled = categoriesOnly || isViewAllTagsMode || !finalCategoryList?.length || ([LOAD_TYPE.initial, LOAD_TYPE.tagsSearchIntoCategory].includes(loadType) && !tagsFilter?.groupIds);
  const shouldCacheValues = true;
  const currentLang = i18n.language || 'en';

  const tagsRequestFilter = useMemo(() => ({
    ...tagsFilter,
    lang: currentLang,
  }), [tagsFilter, currentLang]);

  const [fetchedTags, loadTags] = useGetApiTags(
    tagsRequestFilter,
    currentLang,
    time,
    requestsDisabled,
    appContext,
  );

  const [fetchedAllTags, loadAll] = useGetAllTags({ ...initialAllTagsFilter }, currentLang, time, !isViewAllTagsMode, shouldCacheValues);

  const load = isViewAllTagsMode ? loadAll : loadTags;

  const tags: any[] = useMemo(() => {
    if (isViewAllTagsMode) {
      return fetchedAllTags ?? [];
    }
    return fetchedTags ?? [];
  }, [isViewAllTagsMode, fetchedAllTags, fetchedTags]);

  useEffect(() => {
    currentCategoryRef.current = currentCategory;
  }, [currentCategory]);

  useEffect(() => {
    if (!finalCategoryList?.length) return;

    const firstCategoryId = finalCategoryList[0]?.tagId;
    currentCategoryRef.current = firstCategoryId;
    setTagsFilter({
      ...initialTagsFilter,
      groupIds: [firstCategoryId],
      ...(isCreateLocation ? { entityTypes: [] } : {})
    })
    setCurrentCategory(firstCategoryId);
  }, [finalCategoryList, isCreateLocation, initialTagsFilter, setTagsFilter])

  useEffect(() => {
    if (!currentCategory && !isViewAllTagsMode) {
      setCurrentCategory(tags[0]?.tagId)
    }
  }, [tags, isViewAllTagsMode])

  useEffect(() => {
    if (loadType !== LOAD_TYPE.tagsSearchIntoCategory) {
      const categories = (tags as any[])?.filter((tag: any) => tag.isSearchResult) || []
      const ALL = {
        tagId: 'all',
        title: t('tags_search_all'),
        name: t('tags_search_all'),
        level: 2,
      }
      setFoundCategories([ALL, ...categories]);
    }
  }, [tags, loadType, t])

  const { tagsList, newTag } = useSelector(TagsSelector);

  const isLaboratoryPage = window?.location.pathname.startsWith('/laboratory') || Boolean(window.location.href.split('?').find((l) => l === LABORATORY_PARAM.slice(1)));

  const isGlobalSearch = useMemo(
    () =>
      searchText.length > 0 &&
      (loadType === LOAD_TYPE.tagSearchGlobal
        || loadType === LOAD_TYPE.tagsFetchMore
        || loadType === LOAD_TYPE.tagsFetchMoreLarge
        || loadType === LOAD_TYPE.tagsFetchMoreLargeChild
        || loadType === LOAD_TYPE.tagSearch
        || loadType === LOAD_TYPE.tagSearchIntoTag
        || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
        || loadType === LOAD_TYPE.tagsSearchIntoCategory
        || loadType === LOAD_TYPE.test
        || loadType === LOAD_TYPE.update)
    , [searchText, loadType]);

  useEffect(() => {
    if (!searchText.length && !!finalCategoryList?.length) {
      const category = finalCategoryList[0]?.tagId;
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory);
      setCurrentCategory(category);
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [category],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
    }
  }, [searchText, initialTagsFilter, isCreateLocation])

  const isLocalSearch = useMemo(
    () =>
      loadType === LOAD_TYPE.tagSearch
      || loadType === LOAD_TYPE.tagsSearchIntoCategory
      || loadType === LOAD_TYPE.tagSearchIntoTag
      || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
    , [loadType]);

  const categoryList = useMemo(() => {
    return isGlobalSearch ? foundCategories : finalCategoryList
  }, [isGlobalSearch, foundCategories, finalCategoryList])

  useEffect(() => {
    if (isGlobalSearch) {
      setCurrentCategory('all');
    }
  }, [isGlobalSearch])

  const onModalClose = useCallback((firstTag: Tag): void => {
    if (!firstTag?.tagId) return;
    if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
      window.open("https://ageytomesh.com")
    } else if (firstTag.link) {
      window.open(`${firstTag.link}tag/${firstTag.tagId}`)
    } else {
      history.push(
        isLaboratoryPage ?
          CreateLinkTo.tag(firstTag.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
          isHSEdesign ?
            CreateLinkTo.tag(firstTag.tagId) + APPROVED_HSEDESIGN_PARAM :
            CreateLinkTo.tag(firstTag.tagId)
      )
    }
    modal.hide();
    if (isMobileMenu && mode === 'link') onClose?.();
  }, [history, isHSEdesign, isLaboratoryPage, isMobileMenu, modal, mode, onClose]);

  const onLangSelect = (lang: string) => {
    SaveUserLang(lang as Parameters<typeof SaveUserLang>[0]);
    setAppLang(lang);
    i18n.changeLanguage(lang).then();
  }

  const groupped: IGrouppedTags<Tag[]>[] | undefined = useMemo(() => {
    if (!tags || load) return undefined;

    const result: IGrouppedTags<Tag[]>[] = [];
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i] as any;
      if (!tag) continue;
      result.push({
        isEducationTag: tag.isEducationTag,
        categoryId: tag.tagId,
        groupId: tag.groupId,
        categoryTitle: tag.name,
        isTagCategory: tag.isTagCategory,
        isSearchButton: tag.isSearchButton,
        isSearchResult: tag.isSearchResult,
        isEmptyCategory: tag.isEmptyCategory,
        level: tag.level,
        position: tag.position,
        entityTypes: tag.entityTypes,
        typeCategory: tag.typeCategory,
        found: 0,
        childrens: setInitialChildrens({ childrens: tag.additionalTags }),
        isShowAll: tag.isShowAll,
      });
    }
    return result;
  }, [tags, load]);

  // проверка загружаются ли теги в целом
  const [isLoading, setIsLoading] = useState(false);
  useLayoutEffect(() => {
    if (load && (loadType === LOAD_TYPE.tagSearchGlobal || loadType === LOAD_TYPE.initial)) {
      setIsLoading(true);
    }
    if (groupped && !load) {
      setIsLoading(false);
    }

  }, [load, loadType, groupped])

  const isEmptySearchForAddintTags = useMemo(() => (isEdit && (isGlobalSearch || isLocalSearch) && !load && (!groupped || groupped?.length === 0)), [groupped, isEdit, isGlobalSearch, isLocalSearch, load]);

  const isGlobalEmptySearch = useMemo(() => (loadType === LOAD_TYPE.tagSearchGlobal && (!groupped || groupped?.length === 0)), [loadType, groupped]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const searchedItems: any = useMemo(() => {
    return (ungroup ? ungrouped : tagsList)
      .map((v) => {
        const raw = v?.childrens || []

        const filteredChildrens = viewAllTags && isGlobalSearch ? extractTagChilds(v?.tags) : filterChildrens({
          tagsFilter,
          rawChildrens: raw,
          loadType,
          v,
          isEditProjectPage: isEdit || false,
          isTagsSearchPage
        })

        const hasOverflow = filteredChildrens.length > VISIBLE_CATEGORY_TAGS_LIMIT;
        const childrens = hasOverflow
          ? filteredChildrens.slice(0, VISIBLE_CATEGORY_TAGS_LIMIT)
          : filteredChildrens;

        return {
          ...v,
          position: v?.position,
          childrens,
          isEmptyCategory: !v?.childrens,
          isShowAll: v.isShowAll || hasOverflow,
        }
      })
  }, [ungroup, isGlobalSearch, isTagsSearchPage, viewAllTags, ungrouped, tagsList, tagsFilter, loadType, isEdit]);

  const onSaveTagsByClick = () => {
    onChange && onChange(innerValue)
    modal.hide();
  }

  const setInnerValue = useCallback((arr?: Tag[]) => {
    if (!arr) return;

    const placesTagCount = arr.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities')).length;
    const currentTagsCount = arr.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', { count: maxTeamsTags }));
      setInnerValueFinal(arr.slice(0, arr.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
      toasts.error(t('project_edit.max_project_tags_error', { count: maxProjectTags }));
      setInnerValueFinal(arr.slice(0, arr.length - 1))
      return;
    }
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
      toasts.error(t('project_edit.max_places_tags_error', { count: maxPlacesTags }));
      setInnerValueFinal(arr.slice(0, arr.length - 1))
      return;
    }
    if (!saveOnClick) {
      onChange?.(arr);
    }
    setInnerValueFinal(arr)
    valueRef.current = arr;
  }, [maxProjectTags, saveOnClick, maxPlacesTags, onChange, toasts, maxTeamsTags, t])

  useEffect(() => {
    return () => {
      if (isMobileMenu && mode === 'link') return;
      onClose?.(valueRef.current);
    };
  }, []);


  useEffect(() => {
    if (newTag?.tagId) {
      setInnerValue([...innerValue, newTag])
      dispatch(TagsActions.setNewTag(null))
    }
  }, [dispatch, newTag])

  useEffect(() => {
    const currentInnerValue = innerValue.map(x => x.tagId);
    if (currentInnerValue?.length) {
      setInnerLocalValue(innerValue)
      API.request()
        .endpoint(Endpoints.tagsMnePw)
        .url('/api/Tags/GetTags')
        .addQuery('tagIds', currentInnerValue)
        .lang(i18n.language)
        .send()
        .then((v) => v.json())
        .then((v: any) => {
          setInnerLocalValue(currentInnerValue.map(x => v.find((y: any) => y.tagId === x)))
        });
    } else {
      setInnerLocalValue([]);
    }
  }, [innerValue])

  const innerLocalValue = useMemo(() => {
    return API.toLang(innerLocalValueRaw, i18n.language) as Tag[];
  }, [innerLocalValueRaw, i18n.language])

  const categoryVisible = useMemo(
    () => (!(viewAllTags || (isTagAdminPage && isGlobalSearch && searchedItems?.length === 0 && !!searchText?.length)) && !isCreateLocation) 
  , [viewAllTags, searchedItems, isGlobalSearch, isTagAdminPage, isCreateLocation])

  const getTagsByIds = (ids: string[], tags: Tag[]): Tag[] => {
    var result: Tag[] = [];
    var tagsTems = tags?.filter(x => ids.some(y => y === x.tagId));
    if (tagsTems.length > 0) {
      result.push(...tagsTems);
    }
    tags.forEach(x => {
      if (x.additionalTags.length > 0) {
        const additionalTags = getTagsByIds(ids, x.additionalTags);
        if (additionalTags.length > 0) {
          result.push(...additionalTags);
        }
      }
    });
    return result;
  };

  const limitTagsForUi = useCallback((payload: any) => {
    if (!Array.isArray(payload)) return payload;
    return payload.map((v: any) => {
      const childrens = v?.childrens || [];
      const hasOverflow = childrens.length > VISIBLE_CATEGORY_TAGS_LIMIT;
      if (!hasOverflow) return v;
      return {
        ...v,
        childrens: childrens.slice(0, VISIBLE_CATEGORY_TAGS_LIMIT),
        isShowAll: true,
      };
    });
  }, []);

  const cloneTagsPayload = useCallback((payload: any) => {
    if (!Array.isArray(payload)) return payload;
    return payload.map((v: any) => ({
      ...v,
      childrens: Array.isArray(v?.childrens) ? v.childrens.map((c: any) => ({ ...c })) : v?.childrens,
    }));
  }, []);

  /**
   * Управляющая констукция
   */
  useEffect(() => {
    if (groupped && !load) {
      const cacheKey = tagsFilter?.groupIds?.[0] || currentCategoryRef.current;
      const cacheAndSet = (payload: any, mode: 'set' | 'update' = 'set') => {
        const limited = limitTagsForUi(payload);
        if (cacheKey && limited) {
          processedCategoryCacheRef.current.set(cacheKey, cloneTagsPayload(limited));
        }
        const isStale =
          cacheKey &&
          currentCategoryRef.current &&
          cacheKey !== currentCategoryRef.current &&
          loadType === LOAD_TYPE.tagsSearchIntoCategory;
        if (isStale) {
          return;
        }
        if (mode === 'set') {
          dispatch(TagsActions.setTags(limited));
        } else {
          dispatch(TagsActions.updateTags(limited));
        }
      };

      if (loadType === LOAD_TYPE.initial || loadType === LOAD_TYPE.tagSearchGlobal) {
        cacheAndSet(groupped, 'set');
        setIsLoading(false)
      }
      if ((loadType === LOAD_TYPE.tagSearch || loadType === LOAD_TYPE.update) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.tagsSearchIntoCategory && groupped?.length >= 1) {
        cacheAndSet(groupped, 'set');
      }
      if (loadType === LOAD_TYPE.tagSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.tagGlobalSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      if ((loadType === LOAD_TYPE.tagsFetchMore || loadType === LOAD_TYPE.test) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.tagsFetchMoreLarge && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped, LOAD_TYPE.tagsFetchMoreLarge)))
      }
      if (loadType === LOAD_TYPE.tagsFetchMoreLargeChild && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.updateLang) {
        setLoadType(LOAD_TYPE.initial);
      }
    }
  }, [groupped, load, loadType, dispatch, i18n.language, tagsFilter?.groupIds, limitTagsForUi, cloneTagsPayload])

  useEffect(() => {
    if (mainSearchRef) {
      mainSearchRef.current?.focus()
    }
  }, [mainSearchRef])


  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose(innerValue[0])
    }
  }, [innerValue, onModalClose, mode])

  const onToggleActiveTag = useCallback((id: string | null) => {
    if (activeTag.current === id) {
      activeTag.current = null;
    } else {
      activeTag.current = id;
    }
  }, []);

  const handleApplySearchText = useCallback((e: any) => {
    const str = e.target.value.trim();
    if (str && str.length > 1) {
      const { hasEduTags, ...filteredInitialTagsFilter } = initialTagsFilter;
      setTagsFilter({
        search: [e.target.value],
        ...filteredInitialTagsFilter,
        ...(!!isViewAllTagsMode ? {} : {
          groupIds: [],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {}),
        })
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
      setSearchText(str)
      setTime(Date.now())
    }
    if (str === '') {
      setInitialSearchParam(null)
      setTagsFilter({
        ...initialTagsFilter,
      })
      setSearchText('')
      onToggleActiveTag(null)
      setLoadType(LOAD_TYPE.initial)
      setTime(Date.now())
    }
  }, [initialTagsFilter, isViewAllTagsMode, onToggleActiveTag, setTagsFilter]);

  const debouncedApplySearchText = useMemo(
    () => debounceEvent(handleApplySearchText, 1000),
    [handleApplySearchText],
  );

  const handleSearchInputChange = useCallback((e: any) => {
    setSearchInputValue(e.target.value);
    debouncedApplySearchText(e);
  }, [debouncedApplySearchText]);

  const handleClearSearchClick = useCallback(() => {
    setSearchInputValue('');
    if (mainSearchRef?.current) {
      mainSearchRef.current.value = '';
      mainSearchRef.current.focus?.();
    }
    handleApplySearchText({ target: { value: '' } });
  }, [handleApplySearchText]);

  const handleSearchIntoTagChange = useCallback((e: any, id: string, loadT?: number) => {
    const isCategorySearch = loadT && [LOAD_TYPE.tagsSearchIntoCategory].includes(loadT);
    const isGlobalSearchIntoTag = loadT && [LOAD_TYPE.tagGlobalSearchIntoTag, LOAD_TYPE.tagSearchIntoTag].includes(loadT);
    const entityFilter = !isGlobalSearchIntoTag && { isHeaderIgnored: !!searchText }

    const str = e.target.value.trim();

    if ((str && str.length > 0) || (!isCategorySearch && !isGlobalSearchIntoTag)) {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;
      setTagsFilter({
        groupIds: [id],
        search: [str],
        status: [0],
        isHeaderIgnored: true,
        ...filteredOptionTagsFilter,
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    if (str === '' && isCategorySearch) {
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [id],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(LOAD_TYPE.initial)
    }

    if (str === '' && isGlobalSearchIntoTag) {
      setTagsFilter({
        ...entityFilter,
        ...optionTagsFilter,
        status: [0],
        isHeaderIgnored: true,
      })

      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    setTime(Date.now())

  }, [initialTagsFilter, optionTagsFilter, isCreateLocation])


  const applyCategoryFilter = useCallback((tagId: string) => {
    if (currentCategoryRef.current !== tagId) {
      return;
    }

    if (tagId === 'all') {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;

      setTagsFilter({
        search: searchText ? [searchText] : [],
        status: [0],
        isHeaderIgnored: global,
        groupIds: [],
        ...filteredOptionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
      return;
    }

    setTagsFilter({
      groupIds: [tagId],
      status: [0],
      isHeaderIgnored: global,
      ...optionTagsFilter
    })
    setLoadType(LOAD_TYPE.tagsSearchIntoCategory)
  }, [setTagsFilter, searchText, optionTagsFilter, global])

  const categoryHoverTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCategoryHover = useCallback((tagId: string) => {
    if (categoriesOnly) {
      return;
    }

    if (tagId === currentCategory) {
      return;
    }

    currentCategoryRef.current = tagId;
    setCurrentCategory(tagId);

    if (categoryHoverTimerRef.current) {
      clearTimeout(categoryHoverTimerRef.current);
      categoryHoverTimerRef.current = null;
    }

    const cached = processedCategoryCacheRef.current.get(tagId);
    if (cached) {
      startTransition(() => {
        dispatch(TagsActions.setTags(cloneTagsPayload(cached)));
      });
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory);
      return;
    }

    categoryHoverTimerRef.current = setTimeout(() => {
      categoryHoverTimerRef.current = null;
      applyCategoryFilter(tagId);
    }, 250);
  }, [categoriesOnly, currentCategory, applyCategoryFilter, dispatch, cloneTagsPayload])

  useEffect(() => {
    tagSearchListRef.current?.scrollTo(0, 0);
  }, [currentCategory])

  const handleToggleChildrenClick = useCallback((id: string) => {
    const changed = tagsList.map((c) => {
      const iend = c?.childrens?.filter((k: Tag) => k?.tagId === id)[0];

      if (iend && iend?.level === 1 && iend?.additionalTags?.length === 0) {
        setTagsFilter({
          groupIds: [iend?.tagId],
          status: [0],
          ...optionTagsFilter,
        })
        setLoadType(LOAD_TYPE.update)
        setTime(Date.now())
      }
      
      return c;
    })

    dispatch(TagsActions.setTags(changed))
    onToggleActiveTag(id)
  }, [tagsList, dispatch, optionTagsFilter])

  const handleSetUrlClick = useCallback((id: string): void => {
    if (id) {
      if (isLaboratoryPage) {
        history.push(CreateLinkTo.tag(id + `/${LABORATORY_PARAM}&${APPROVED_HSEDESIGN_PARAM.slice(1)}`))
      } else if (isHSEdesign) {
        history.push(CreateLinkTo.tag(id + '/' + APPROVED_HSEDESIGN_PARAM))
      } else {
        history.push(CreateLinkTo.tag(id))
      }
      modal.hide();
    }
  }, [isLaboratoryPage, isHSEdesign, history, modal])

  const handleMoreClick = useCallback((id: string, loadT?: number) => {
    setTagsFilter({
      groupIds: [id],
      status: [0],
      isHeaderIgnored: true,
      ...optionTagsFilter
    })

    setTime(Date.now())
    setLoadType(loadT || LOAD_TYPE.update)
  }, [])

  const foundTagsRef = useRef<HTMLDivElement>(null);
  const [resultTagsHeight, setResultTagsHeight] = useState(is992 ? 170 : 380);

  const graveStyle = {
      fontFamily: 'Inter',
      fontWeight: 400,
      padding: '2px 8px 4px 8px', 
      fontSize: '11px', 
      lineHeight: '13px', 
      letterSpacing: '-0.02em',
      color: '#fff',
      backgroundColor: '#2C2C2B',
      background: '#2C2C2B',
      textColor: '#fff',
      id: 'tooltip-parent-element',
      className: 'tooltip-parent-element',
    }
    const tooltipStyles = (!isCGRAVE && !isContinuumSite) ? getTooltipStyles(theme) : graveStyle

  const currentCategoryName = useMemo(() => {
    return categoryList?.find((c) => c?.tagId === currentCategory)?.name || ''
  }, [categoryList, currentCategory])

  const selectedCategoryIds = useMemo(
    () => innerValue.filter((v: any) => v?.isTagCategory).map((v: any) => v.tagId),
    [innerValue],
  )

  const handleCategoryClick = useCallback((tag: any) => {
    if (!allowCategorySelect || !tag?.tagId) return;
    const alreadySelected = innerValue.some((v: any) => v?.tagId === tag.tagId && v?.isTagCategory);
    if (alreadySelected) {
      setInnerValue(innerValue.filter((v: any) => v?.tagId !== tag.tagId));
    } else {
      setInnerValue([...innerValue, { ...tag, isTagCategory: true }]);
    }
  }, [allowCategorySelect, innerValue, setInnerValue])

  useEffect(() => {

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setResultTagsHeight(entry.target.getBoundingClientRect().height + (isLinkMode ? (is992 ? 200 : 250) : (is992 ? 144 : 353)))
      }
    })

    if (foundTagsRef?.current) {
      resizeObserver.observe(foundTagsRef?.current)
    }

    return () => {
      if (foundTagsRef?.current) {
        resizeObserver.unobserve(foundTagsRef?.current)
      }
    }
  }, [is992])

  if (isCreateMode) {
    return (
      <CreateTagComponent 
        onClose={() => setIsCreateMode(false)} 
        onCreateTag={onAfterTagCreate} 
      />
    )
  }

  return (
    <TagsSearchModalWrapper>
      {!isLinkMode && !is992 && (
        <LangSelectHolder>
          <LangSwitcher
            currentLanguage={i18n.language}
            onLangSelect={onLangSelect}
            key="lang"
          />
        </LangSelectHolder>
      )}
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {!isLinkMode && saveOnClick && (
          <TitleContainer>
            <TagsSearchTitle color={theme.tagSearch.titleColor}>
              {t(mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
            </TagsSearchTitle>
            <SubmitButton variant={ButtonVariant.Filled} className='select-tags-modal--save-button' onClick={onSaveTagsByClick}>{t('save_tag')}</SubmitButton>
          </TitleContainer>
        )}
        {!isLinkMode && !saveOnClick && (
          <TagsSearchTitle color={theme.tagSearch.titleColor}>
            {t(isTagEditor ? 'tag_editor' : mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
          </TagsSearchTitle>
        )}
        {!hideGlobalSearchBar && !(isHseSpace && isCompetencies) && (
          <TagsSearchInputWrapper
            isCGRAVE={isCGRAVE || isContinuumSite}
            offsetTop={(is992 && isMobileMenu) ? 20 : isLinkMode ? 0 : (is992 ? 16 : 48)}
            isMobileMenu={is992 && isMobileMenu}
            gx={12}
          >
            <SearchIcon fill={theme.tags.modal.search.color}/>
            <TagsSearchInput
              ref={mainSearchRef}
              value={searchInputValue}
              onChange={handleSearchInputChange}
              placeholder={t('tags_modal.search_mobile')}
            />
            {searchInputValue.length > 0 && (
              <ClearSearchButton type="button" onClick={handleClearSearchClick} aria-label="Clear search">
                <ClearSearchIcon />
              </ClearSearchButton>
            )}
          </TagsSearchInputWrapper>
        )}
        {(!isMobile && !isGlobalEmptySearch) && (
          <TagsSearchSelection
            ref={foundTagsRef}
            style={{
              display: 'flex',
              flexFlow: 'row',
              margin: '0',
              paddingTop: innerValue.length > 0 ? '24px' : '8px',
              paddingBottom: innerValue.length > 0 ? '14px' : 0,
            }}>
            {!isLinkMode && !!innerValue.length && (
              <TagsSelectedTitle
                style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
              >
                {(!!innerValue.length && mode !== 'link') ? (isTagEditor ? `${t('tags_in_project')}:` : `${t('tags_modal.selected_tags')}:`) : t('tags_modal.select_tags')}
              </TagsSelectedTitle>
            )}
            {
              !!innerLocalValue.length && (
                <BTagsGridNew className='selected-tags-grid'>
                  {mode !== 'link' &&
                  innerLocalValue.map((v: any) => (
                    <BTag
                      tag={v}
                      removable={true}
                      key={v.tagId}
                      educational={isRequired(v)}
                      organization={v?.isTeamTag}
                      showRemoveIcon={!(isTagEditor && !editableTags.includes(v.tagId) && !isModer)}
                      disabled={!!isTagEditor && !editableTags.includes(v.tagId) && !isModer}
                      onIconClick={() => {
                        if (isTagEditor && !editableTags.includes(v.tagId) && !isModer) {
                            return;
                        }
                        if (protectedTags.includes(v.tagId)) {
                          toasts.error('Это обязательный тег');
                        } else {
                          const vi = innerValue.filter((t) => t.tagId !== v.tagId);
                          ReactTooltip.hide()
                          setInnerValue(vi);
                        }
                      }}
                    >
                      {bTag.title(v)}
                    </BTag>
                  ))}
                </BTagsGridNew>
              )}
          </TagsSearchSelection>
        )}
          {isTagEditor &&
              <TagsAvailableTitle
              style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
          >
            {t('available_tags_in_project')}
          </TagsAvailableTitle>}
        <TagsSearchResultsWrapper
            direction={isViewAllTagsMode ? 'column' : 'row'}
            gx={is992 ? 16 : 24}
            offsetTop={!!innerValue?.length ? 16 : 22}
            shadowColor={theme.app.backgroundColor}
        >
          {isGlobalEmptySearch && !isLoading && (
            <EmptyTextWrapper direction="column" gy={24} isIqMediia={isIqMediia} width="100%" align="center" justify="center">
              <EmptyText>{t("tags_modal.empty_search_select_from_list")}</EmptyText>
              {(isTagAdminPage || viewAllTags) && <BrgButton variant={ButtonVariant.Filled} onClick={() => setIsCreateMode(true)}>{t("tags_modal.create_tag")}</BrgButton>}
            </EmptyTextWrapper>
          )}
          {categoryVisible && !isGlobalEmptySearch && (
              <>
                <CategoryList
                    tags={categoryList}
                    onHover={handleCategoryHover}
                    currentCategory={currentCategory}
                    customHeight={is992 ? 330 : resultTagsHeight}
                    isClickable={isLinkMode}
                    fullWidth={categoriesOnly}
                    setHideMore={setHideMore}
                    onCategoryClick={allowCategorySelect ? handleCategoryClick : undefined}
                    selectedCategoryIds={selectedCategoryIds}
                />
                {is992 && <ModalContextSplitLine/>}
              </>
          )}
          {isLoading && (
            <FlexBox justify="center" width='100%' style={{ height: resultTagsHeight }}>
              <LoaderSpinner color={theme.selectContextModal.loaderText} text={t('project_edit.modal.load_msg_tag')}/>
            </FlexBox>
          )}
          {!categoriesOnly && !isLoading && (
            <TagsSearchResults
              customHeight={resultTagsHeight}
              direction={'column'}
              directionMobile={"column"}
              width={'100%'}
              ref={tagSearchListRef}
            >
              <TagsSearchResultsContext
                  direction={'column'}
                  directionMobile={'column'}
                  width={'100%'}
                  isGlobalSearch={isGlobalSearch}
              >
                <BTagsGridNew
                    style={{
                      position: 'relative',
                      height: 'auto',
                      paddingBottom: '10px'
                    }}
                    noLimitMaxHeight
                >
                  {<TabletTitle
                      onClick={() => {
                        if (!is992) return;
                        history.push(CreateLinkTo.tag(currentCategory || ''));
                      }}
                      width='100%'
                      gx={8}
                      offsetBottom={is992 ? 14 : 4}
                      align="center">
                        <span>{currentCategoryName}</span>
                        {is992 && <ArrowTopRightIcon/>}
                  </TabletTitle>}
                  {searchedItems
                    .map((g: any) => {
                      const items = isViewAllTagsMode ? g?.tags : g?.childrens;
                      return (
                        <TagsSearchResultsItem
                          hideMore={hideMore}
                          setHideMore={setHideMore}
                          isViewAllTagsMode={viewAllTags}
                          search={searchText}
                          key={g?.categoryId}
                          activeTagId={activeTag.current || ''}
                          title={g?.categoryTitle}
                          identifier={g?.categoryId}
                          items={items}
                          found={g?.found}
                          isCategorySearchNeed={g?.isSearchButton}
                          searchingIntoTag={isLocalSearch}
                          isSelected={(id) => innerValue.some((v) => v?.tagId === id)}
                          isCategoryTag={g?.isTagCategory}
                          onClick={(tag: any, selected) => {
                            let v = innerValue;
                            if (!selected) {
                              const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);

                              if (mode === 'link' || max === 1) {
                                v = [tag];
                              } else if (maxEducationalTags === 1 && tag?.isEducationTag && educationalTags.length >= 1) {
                                v = [...innerValue.filter((t) => !t.isEducationTag), tag];
                              } else if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
                                toasts.error(maxEducationalTags > 1
                                  ? t('project_edit.max_education_tags_error', { count: maxEducationalTags })
                                  : t('project_edit.max_required_tags_error'))
                              } else if (max && innerValue?.length + 1 > max) {
                                toasts.error(
                                  maxTagsExceededMessageKey
                                    ? t(maxTagsExceededMessageKey)
                                    : t('project_edit.select_tags_max_error', { count: max }),
                                );
                                v = innerValue;
                              } else {
                                v = [...innerValue, tag];
                              }
                            } else if (protectedTags.includes(tag?.tagId)) {
                              toasts.error('Это обязательный тег');
                              return;
                            } else {
                              v = innerValue.filter((t) => t.tagId !== tag.tagId);
                            }
                            setInnerValue(v);
                          }}
                          onTagArrowClick={handleToggleChildrenClick}
                          onParentClick={handleSetUrlClick}
                          onMoreClick={handleMoreClick}
                          onSearchInputChange={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          onSearchIntoCategory={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          setIsOpenTag={setIsOpenTag}
                          isEditPage={isEdit || isCreateLocationPage}
                          loadType={loadType}
                          isEmptySearch={isEmptySearchForAddintTags}
                          tagsFilter={tagsFilter}
                          setTime={setTime}
                          isGlobalSearch={isGlobalSearch}
                          isShowAll={g.isShowAll}
                          isLinkMode={isLinkMode}
                          isCreateLocationPage={isCreateLocationPage}
                        />
                      );
                    })}
                  <ReactTooltip  {...tooltipStyles}/>
                </BTagsGridNew>
              </TagsSearchResultsContext>
              {isViewAllTagsMode && (
                <SimplePagination 
                  page={Number(page || 1)} 
                  pages={
                    fetchedAllTags.length >= ALL_TAGS_LIMIT
                      ? Number(page || 1) + 1
                      : Math.max(1, Number(page || 1))
                  } 
                  onPageChange={handlePageChange} 
                  disableOffset
                />
              )}
            </TagsSearchResults>
          )}
        </TagsSearchResultsWrapper>
      </TagsSearchModalContainer>
      <ReactTooltip/>
    </TagsSearchModalWrapper>
  );
};
import { FC, startTransition, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import ReactTooltip from "react-tooltip";
import { useToasts, FlexBox, BLangSwitcher, useBreakpoint, ButtonVariant, BrgButton } from '@brg/ui';
import { API, Endpoints, Tag } from '@brg/api';
import {
  TagsAvailableTitle,
  ModalContextSplitLine, TabletTitle,
  TagsSearchInput,
  TagsSearchInputWrapper,
  TagsSearchModalContainer,
  TagsSearchModalWrapper,
  TagsSearchResults,
  TagsSearchResultsContext,
  TagsSearchSelection,
  TagsSearchTitle,
  TagsSelectedTitle,
  SubmitButton,
  LangSelectHolder,
  TagsSearchResultsWrapper,
  TitleContainer,
} from './styles';
import { TagsSearchResultsItem } from './tagsSearchResultsItem';
import { BTag } from '../../../core/components';
import { bTag, LayoutConst, useModal } from '../../../core';
import { ITagsProps } from 'shared/hooks/api/useTagsList';
import { EmptyText, EmptyTextWrapper } from './FoundTags';
import { debounceEvent } from 'shared/utils/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { TagsActions, TagsSelector } from 'shared/reducers/Tags';
import { ArrowTopRightIcon, SearchIcon } from 'shared/icons';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { AGEYTOMESH_TAG_ID } from 'shared/constants/misc';
import { getSearched, getUpdated } from './support/updateTag';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { filterChildrens } from './support/filterChildrens';
import { AppTester } from 'supporting';
import { SaveUserLang } from "../../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../../components/__ADDONS__/__LANG__/Slice";
import { setInitialChildrens } from './support/setInitialChildrens';
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { isRequired } from './support/isRequired';
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import CategoryList from "./CategoryList";
import { useGetAllTags } from 'shared/hooks/api/useGetAllTags';
import useQueryState from 'shared/hooks/useQueryState';
import { SimplePagination } from 'shared/components/pagination/SimplePagination';
import { extractTagChilds } from './support/extractTagChilds';
import { removeUndefined } from "../../helpers/removeUndefined";
import { CreateTagButton } from './components/CreateTagComponent/style';
import { CreateTagComponent } from './components/CreateTagComponent/CreateTagComponent';
import { getTooltipStyles } from 'shared/constants/tooptipStyles';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {useGetApiTags} from "../../hooks/api/useGetApiTags";
import {bProfile} from "../../../core/utils/bProfile";
import {useProfile} from "@brg/auth";
import { useInitialCategories } from './support/useInitialCategoires';
import { SelectTagsModalProps } from './types';
import LangSwitcher from 'shared/components/LangSwitcher/LangSwitcher';

export interface IGrouppedTags<T> {
  isEducationTag?: boolean;
  categoryId?: string;
  childrens?: T;
  found?: number;
  position?: number;
  groupId?: string | null;
  categoryTitle?: string;
  isTagCategory?: boolean;
  isSearchButton?: boolean;
  isSearchResult?: boolean;
  isMoreButton?: boolean;
  isEmptyCategory?: boolean;
  level?: number;
  entityTypes?: string[];
  typeCategory?: string;
  isShowAll?: boolean;
}

export enum LOAD_TYPE {
  initial = 1,
  update = 2,
  tagSearch = 3,
  tagsSearchIntoCategory = 4,
  tagSearchIntoTag = 5,
  tagGlobalSearchIntoTag = 6,
  tagSearchGlobal = 7,
  tagsFetchMore = 8,
  tagsFetchMoreLarge = 9,
  tagsFetchMoreLargeChild = 10,
  test = 11,
  updateLang = 12
}

export const LABORATORY_PARAM = '?_lab';
export const APPROVED_HSEDESIGN_PARAM = '';
export const REQUIRED_TAG_ID = '390ea8c2329fc0bc9c389a1b0f1f6e4d';
export const EDUCATIONAL_CATEGORY_ID = 'c326e5a4bd0b02c9c338fe382ac1f9a8';
export const ALL_TAGS_LIMIT = 100;
/** Cap right-panel render — categories like cities/places have 1.5k–3k tags */
export const VISIBLE_CATEGORY_TAGS_LIMIT = 80;

const ClearSearchButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

const ClearSearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_19454_17501)">
      <path d="M7.9999 9.03564L1.72535 15.3102C1.47255 15.563 1.06065 15.5644 0.812094 15.3075C0.756406 15.2499 0.725178 15.2165 0.706523 15.1957C0.463197 14.925 0.4441 14.52 0.701494 14.2626L6.96417 7.9999L0.6896 1.72534C0.4368 1.47254 0.4368 1.06267 0.6896 0.809868L0.809867 0.689601C1.06267 0.4368 1.47254 0.4368 1.72534 0.689601L7.9999 6.96417L14.2745 0.689601C14.5273 0.4368 14.9371 0.4368 15.1899 0.689601L15.3102 0.809868C15.563 1.06267 15.563 1.47254 15.3102 1.72534L9.03564 7.9999L15.3102 14.2745C15.563 14.5273 15.5644 14.9392 15.3075 15.1877C15.2499 15.2434 15.2165 15.2746 15.1957 15.2933C14.925 15.5366 14.52 15.5557 14.2626 15.2983L7.9999 9.03564Z" fill="#909090"/>
    </g>
    <defs>
      <clipPath id="clip0_19454_17501">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);


export const SelectTagsModal: FC<SelectTagsModalProps> = (props) => {
  const {
    value, onChange,
    mode,
    ctx,
    isCompetencies,
    max,
    maxProjectTags,
    maxPlacesTags,
    maxTeamsTags,
    onClose,
    onAfterTagCreate,
    hideGlobalSearchBar,
    maxEducationalTags,
    ungroup,
    protectedTags = [],
    editableTags = [],
    requiredTags,
    isTagEditor,
    isMobileMenu,
    isTagAdminPage,
    isEdit,
    educational,
    isCreateLocation,
    global: globalProp,
    hasEduTags,
    saveOnClick = true,
    viewAllTags,
    ignoreHeader,
    maxTagsExceededMessageKey,
    allowCategorySelect,
    categoriesOnly,
  } = props;

  const [innerValue, setInnerValueFinal] = useState<Tag[]>(value ?? []);
  const [innerLocalValueRaw, setInnerLocalValue] = useState<Tag[]>([]);
  const location = useLocation();
  const valueRef = useRef<Tag[]>([]);
  const prevLangRef = useRef<string | null>(null);
  const tagSearchListRef = useRef<HTMLDivElement>(null);
  const activeTag = useRef<any>(null)
  const mainSearchRef = useRef<any>(null);
  /** Processed right-panel payload per category — skip fetch/regroup on revisit */
  const processedCategoryCacheRef = useRef<Map<string, any>>(new Map());
  const currentCategoryRef = useRef<string | null>(null);
  const toasts = useToasts();
  const dispatch = useDispatch();
  const history = useHistory();
  const isTagsSearchPage = location.pathname.startsWith('/tags');
  const isEditProjectPage = location.pathname.startsWith('/edit');
  const isCreateLocationPage = location.pathname.startsWith('/createLocation');
  const isBrnd = AppTester.isBrnd();
  const isStartHSE = AppTester.isStartHSE();
  const [{ page }, setQueryState ] = useQueryState();

  const [hideMore, setHideMore] = useState(false);

  const isHSEdesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isIqMediia = AppTester.isIqMediiia();
  const isHseSpace = AppTester.isHseSpace();
  const isAKI = AppTester.isAKI();
  const isHseSpaceSubcontext = AppTester.isHSESpaceSegmants();
  const isFilmRoute = !!useRouteMatch('/film');
  const isMobile = useBreakpoint(LayoutConst.screen.s);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const theme = useTheme();
  const modal = useModal();
  const { t, i18n } = useTranslation();
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [foundCategories, setFoundCategories] = useState<any[]>([]);
  const [searchText, setSearchText] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [searchInitialParam, setInitialSearchParam] = useState<any>(null);
  const [currentCategory, setCurrentCategory] = useState<string | null>(null);
  const profile = useProfile()
  const isModer = !!profile && (bProfile.isModer(profile) || bProfile.isSuperModer(profile))
  const global = useMemo(() => ((Boolean(isTagEditor && !isModer && !!editableTags?.length)) || globalProp),
      [isModer, globalProp, isTagEditor, editableTags?.length])

  const handlePageChange = (p: number ) => {
    setQueryState({ page: p })
    setTime(Date.now());
  }

  const isLinkMode = mode === 'link';

  const optionTagsFilter = useMemo(() => {
    const shouldApplyEducationFilter = isHseSpace 
      ? (isEdit && isHseSpace)
      : !isHseSpace;
    
    return {
      isModeEditing: isEdit || false,
      ...(isHseSpace && isTagsSearchPage ? {
        isEducation: false,
        hasEduTags: false,
      } : (shouldApplyEducationFilter && (isStartHSE && isTagsSearchPage ? {
        isEducation: true,
      } : educational !== undefined ? {
        isEducation: educational,
      } : {}))),
    ...(ctx  ? {
      entityTypes: ctx,
    } : {}),
    ...(isTagEditor && !isModer && editableTags ? {
      tagIds: editableTags || [],
    } : {}),
    ...(global ? {
      isHeaderIgnored: global,
    } : {}),
    ...(hasEduTags !== undefined && !isAKI && !(isStartHSE ||isHseSpace && isTagsSearchPage) ? {
      hasEduTags: hasEduTags,
    } : {}),
    ...(isBrnd && isEdit && ignoreHeader !== false ? {
      isHeaderIgnored: true,
    } : {}),
    };
  }, [isModer, isEdit, educational, isTagEditor, global, ctx, hasEduTags, isStartHSE, isTagsSearchPage, isHseSpace, isHseSpaceSubcontext, isAKI])

  useEffect(() => {
    if (
      searchText?.length && 
      isLinkMode && 
      prevLangRef.current && 
      prevLangRef.current !== i18n.language
    ) {
      setInitialSearchParam({ search: [ searchText ] })
    }
    prevLangRef.current = i18n.language
  } , [i18n.language, isLinkMode, searchText, prevLangRef.current])

  const initialTagsFilter = useMemo(() => ({
    ...optionTagsFilter,
    ...(isTagEditor ? { status: [0, 1] } : { status: [0] }),
    lang: i18n.language,
    ...(searchInitialParam ? searchInitialParam : {})
  }), [i18n.language, optionTagsFilter, searchInitialParam, isTagEditor])


  const appContext = isFilmRoute ? 'filmhsespace' : '';
  
  const initialCategoryList = useInitialCategories(optionTagsFilter);

  const finalCategoryList = useMemo(() => {

    return initialCategoryList
  } , [initialCategoryList])

  const initialAllTagsFilter = useMemo(() => ({
    status: [0],
    levels: [1],
    isHeaderIgnored: true,
    includeCount: true,
    limit: ALL_TAGS_LIMIT,
    page: page ? Number(page) : 1
  }), [ctx, i18n.language, page, isEditProjectPage])

  const [tagsFilter, setTagsFilterFinal] = useState<ITagsProps>(initialTagsFilter);

  const setTagsFilter = useCallback((filter: ITagsProps) => {
    setTagsFilterFinal({
      ...removeUndefined(filter)
    })
  }, [optionTagsFilter, requiredTags])

  const [loadType, setLoadType] = useState<number>(LOAD_TYPE.initial);
  const [time, setTime] = useState(Date.now());
  const [_, setIsOpenTag] = useState<boolean>(false); /** TODO: почистить и проверить компоненты, в которые пробрасывается сеттер  */

  const isViewAllTagsMode = useMemo(() => {
    return viewAllTags && loadType !== LOAD_TYPE.tagSearchGlobal
  } , [viewAllTags, loadType])

  const requestsDisabled = categoriesOnly || isViewAllTagsMode || !finalCategoryList?.length || ([LOAD_TYPE.initial, LOAD_TYPE.tagsSearchIntoCategory].includes(loadType) && !tagsFilter?.groupIds);
  const shouldCacheValues = true;
  const currentLang = i18n.language || 'en';

  const tagsRequestFilter = useMemo(() => ({
    ...tagsFilter,
    lang: currentLang,
  }), [tagsFilter, currentLang]);

  const [fetchedTags, loadTags] = useGetApiTags(
    tagsRequestFilter,
    currentLang,
    time,
    requestsDisabled,
    appContext,
  );

  const [fetchedAllTags, loadAll] = useGetAllTags({ ...initialAllTagsFilter }, currentLang, time, !isViewAllTagsMode, shouldCacheValues);

  const load = isViewAllTagsMode ? loadAll : loadTags;

  const tags: any[] = useMemo(() => {
    if (isViewAllTagsMode) {
      return fetchedAllTags ?? [];
    }
    return fetchedTags ?? [];
  }, [isViewAllTagsMode, fetchedAllTags, fetchedTags]);

  useEffect(() => {
    currentCategoryRef.current = currentCategory;
  }, [currentCategory]);

  useEffect(() => {
    if (!finalCategoryList?.length) return;

    const firstCategoryId = finalCategoryList[0]?.tagId;
    currentCategoryRef.current = firstCategoryId;
    setTagsFilter({
      ...initialTagsFilter,
      groupIds: [firstCategoryId],
      ...(isCreateLocation ? { entityTypes: [] } : {})
    })
    setCurrentCategory(firstCategoryId);
  }, [finalCategoryList, isCreateLocation, initialTagsFilter, setTagsFilter])

  useEffect(() => {
    if (!currentCategory && !isViewAllTagsMode) {
      setCurrentCategory(tags[0]?.tagId)
    }
  }, [tags, isViewAllTagsMode])

  useEffect(() => {
    if (loadType !== LOAD_TYPE.tagsSearchIntoCategory) {
      const categories = (tags as any[])?.filter((tag: any) => tag.isSearchResult) || []
      const ALL = {
        tagId: 'all',
        title: t('tags_search_all'),
        name: t('tags_search_all'),
        level: 2,
      }
      setFoundCategories([ALL, ...categories]);
    }
  }, [tags, loadType, t])

  const { tagsList, newTag } = useSelector(TagsSelector);

  const isLaboratoryPage = window?.location.pathname.startsWith('/laboratory') || Boolean(window.location.href.split('?').find((l) => l === LABORATORY_PARAM.slice(1)));

  const isGlobalSearch = useMemo(
    () =>
      searchText.length > 0 &&
      (loadType === LOAD_TYPE.tagSearchGlobal
        || loadType === LOAD_TYPE.tagsFetchMore
        || loadType === LOAD_TYPE.tagsFetchMoreLarge
        || loadType === LOAD_TYPE.tagsFetchMoreLargeChild
        || loadType === LOAD_TYPE.tagSearch
        || loadType === LOAD_TYPE.tagSearchIntoTag
        || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
        || loadType === LOAD_TYPE.tagsSearchIntoCategory
        || loadType === LOAD_TYPE.test
        || loadType === LOAD_TYPE.update)
    , [searchText, loadType]);

  useEffect(() => {
    if (!searchText.length && !!finalCategoryList?.length) {
      const category = finalCategoryList[0]?.tagId;
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory);
      setCurrentCategory(category);
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [category],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
    }
  }, [searchText, initialTagsFilter, isCreateLocation])

  const isLocalSearch = useMemo(
    () =>
      loadType === LOAD_TYPE.tagSearch
      || loadType === LOAD_TYPE.tagsSearchIntoCategory
      || loadType === LOAD_TYPE.tagSearchIntoTag
      || loadType === LOAD_TYPE.tagGlobalSearchIntoTag
    , [loadType]);

  const categoryList = useMemo(() => {
    return isGlobalSearch ? foundCategories : finalCategoryList
  }, [isGlobalSearch, foundCategories, finalCategoryList])

  useEffect(() => {
    if (isGlobalSearch) {
      setCurrentCategory('all');
    }
  }, [isGlobalSearch])

  const onModalClose = useCallback((firstTag: Tag): void => {
    if (!firstTag?.tagId) return;
    if (firstTag.tagId === AGEYTOMESH_TAG_ID) {
      window.open("https://ageytomesh.com")
    } else if (firstTag.link) {
      window.open(`${firstTag.link}tag/${firstTag.tagId}`)
    } else {
      history.push(
        isLaboratoryPage ?
          CreateLinkTo.tag(firstTag.tagId) + LABORATORY_PARAM + '&' + APPROVED_HSEDESIGN_PARAM?.slice(1) :
          isHSEdesign ?
            CreateLinkTo.tag(firstTag.tagId) + APPROVED_HSEDESIGN_PARAM :
            CreateLinkTo.tag(firstTag.tagId)
      )
    }
    modal.hide();
    if (isMobileMenu && mode === 'link') onClose?.();
  }, [history, isHSEdesign, isLaboratoryPage, isMobileMenu, modal, mode, onClose]);

  const onLangSelect = (lang: string) => {
    SaveUserLang(lang as Parameters<typeof SaveUserLang>[0]);
    setAppLang(lang);
    i18n.changeLanguage(lang).then();
  }

  const groupped: IGrouppedTags<Tag[]>[] | undefined = useMemo(() => {
    if (!tags || load) return undefined;

    const result: IGrouppedTags<Tag[]>[] = [];
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i] as any;
      if (!tag) continue;
      result.push({
        isEducationTag: tag.isEducationTag,
        categoryId: tag.tagId,
        groupId: tag.groupId,
        categoryTitle: tag.name,
        isTagCategory: tag.isTagCategory,
        isSearchButton: tag.isSearchButton,
        isSearchResult: tag.isSearchResult,
        isEmptyCategory: tag.isEmptyCategory,
        level: tag.level,
        position: tag.position,
        entityTypes: tag.entityTypes,
        typeCategory: tag.typeCategory,
        found: 0,
        childrens: setInitialChildrens({ childrens: tag.additionalTags }),
        isShowAll: tag.isShowAll,
      });
    }
    return result;
  }, [tags, load]);

  // проверка загружаются ли теги в целом
  const [isLoading, setIsLoading] = useState(false);
  useLayoutEffect(() => {
    if (load && (loadType === LOAD_TYPE.tagSearchGlobal || loadType === LOAD_TYPE.initial)) {
      setIsLoading(true);
    }
    if (groupped && !load) {
      setIsLoading(false);
    }

  }, [load, loadType, groupped])

  const isEmptySearchForAddintTags = useMemo(() => (isEdit && (isGlobalSearch || isLocalSearch) && !load && (!groupped || groupped?.length === 0)), [groupped, isEdit, isGlobalSearch, isLocalSearch, load]);

  const isGlobalEmptySearch = useMemo(() => (loadType === LOAD_TYPE.tagSearchGlobal && (!groupped || groupped?.length === 0)), [loadType, groupped]);

  const ungrouped: any[] = useMemo(
    () => [
      {
        categoryId: "all",
        categoryTitle: "All",
        tags: (tags ?? []),
        found: 0,
        position: 2,
      }
    ],
    [tags],
  );

  const searchedItems: any = useMemo(() => {
    return (ungroup ? ungrouped : tagsList)
      .map((v) => {
        const raw = v?.childrens || []

        const filteredChildrens = viewAllTags && isGlobalSearch ? extractTagChilds(v?.tags) : filterChildrens({
          tagsFilter,
          rawChildrens: raw,
          loadType,
          v,
          isEditProjectPage: isEdit || false,
          isTagsSearchPage
        })

        const hasOverflow = filteredChildrens.length > VISIBLE_CATEGORY_TAGS_LIMIT;
        const childrens = hasOverflow
          ? filteredChildrens.slice(0, VISIBLE_CATEGORY_TAGS_LIMIT)
          : filteredChildrens;

        return {
          ...v,
          position: v?.position,
          childrens,
          isEmptyCategory: !v?.childrens,
          isShowAll: v.isShowAll || hasOverflow,
        }
      })
  }, [ungroup, isGlobalSearch, isTagsSearchPage, viewAllTags, ungrouped, tagsList, tagsFilter, loadType, isEdit]);

  const onSaveTagsByClick = () => {
    onChange && onChange(innerValue)
    modal.hide();
  }

  const setInnerValue = useCallback((arr?: Tag[]) => {
    if (!arr) return;

    const placesTagCount = arr.filter((i) => i?.entityTypes?.includes('places') || i?.entityTypes?.includes('geotag') || i?.entityTypes?.includes('cities')).length;
    const currentTagsCount = arr.length - placesTagCount;

    if (maxTeamsTags && (currentTagsCount > maxTeamsTags)) {
      toasts.error(t('project_edit.max_team_project_tags_error', { count: maxTeamsTags }));
      setInnerValueFinal(arr.slice(0, arr.length - 1))
      return;
    }

    if (maxProjectTags && (currentTagsCount > maxProjectTags)) {
      toasts.error(t('project_edit.max_project_tags_error', { count: maxProjectTags }));
      setInnerValueFinal(arr.slice(0, arr.length - 1))
      return;
    }
    if (maxPlacesTags && (placesTagCount > maxPlacesTags)) {
      toasts.error(t('project_edit.max_places_tags_error', { count: maxPlacesTags }));
      setInnerValueFinal(arr.slice(0, arr.length - 1))
      return;
    }
    if (!saveOnClick) {
      onChange?.(arr);
    }
    setInnerValueFinal(arr)
    valueRef.current = arr;
  }, [maxProjectTags, saveOnClick, maxPlacesTags, onChange, toasts, maxTeamsTags, t])

  useEffect(() => {
    return () => {
      if (isMobileMenu && mode === 'link') return;
      onClose?.(valueRef.current);
    };
  }, []);


  useEffect(() => {
    if (newTag?.tagId) {
      setInnerValue([...innerValue, newTag])
      dispatch(TagsActions.setNewTag(null))
    }
  }, [dispatch, newTag])

  useEffect(() => {
    const currentInnerValue = innerValue.map(x => x.tagId);
    if (currentInnerValue?.length) {
      setInnerLocalValue(innerValue)
      API.request()
        .endpoint(Endpoints.tagsMnePw)
        .url('/api/Tags/GetTags')
        .addQuery('tagIds', currentInnerValue)
        .lang(i18n.language)
        .send()
        .then((v) => v.json())
        .then((v: any) => {
          setInnerLocalValue(currentInnerValue.map(x => v.find((y: any) => y.tagId === x)))
        });
    } else {
      setInnerLocalValue([]);
    }
  }, [innerValue])

  const innerLocalValue = useMemo(() => {
    return API.toLang(innerLocalValueRaw, i18n.language) as Tag[];
  }, [innerLocalValueRaw, i18n.language])

  const categoryVisible = useMemo(
    () => (!(viewAllTags || (isTagAdminPage && isGlobalSearch && searchedItems?.length === 0 && !!searchText?.length)) && !isCreateLocation) 
  , [viewAllTags, searchedItems, isGlobalSearch, isTagAdminPage, isCreateLocation])

  const getTagsByIds = (ids: string[], tags: Tag[]): Tag[] => {
    var result: Tag[] = [];
    var tagsTems = tags?.filter(x => ids.some(y => y === x.tagId));
    if (tagsTems.length > 0) {
      result.push(...tagsTems);
    }
    tags.forEach(x => {
      if (x.additionalTags.length > 0) {
        const additionalTags = getTagsByIds(ids, x.additionalTags);
        if (additionalTags.length > 0) {
          result.push(...additionalTags);
        }
      }
    });
    return result;
  };

  const limitTagsForUi = useCallback((payload: any) => {
    if (!Array.isArray(payload)) return payload;
    return payload.map((v: any) => {
      const childrens = v?.childrens || [];
      const hasOverflow = childrens.length > VISIBLE_CATEGORY_TAGS_LIMIT;
      if (!hasOverflow) return v;
      return {
        ...v,
        childrens: childrens.slice(0, VISIBLE_CATEGORY_TAGS_LIMIT),
        isShowAll: true,
      };
    });
  }, []);

  const cloneTagsPayload = useCallback((payload: any) => {
    if (!Array.isArray(payload)) return payload;
    return payload.map((v: any) => ({
      ...v,
      childrens: Array.isArray(v?.childrens) ? v.childrens.map((c: any) => ({ ...c })) : v?.childrens,
    }));
  }, []);

  /**
   * Управляющая констукция
   */
  useEffect(() => {
    if (groupped && !load) {
      const cacheKey = tagsFilter?.groupIds?.[0] || currentCategoryRef.current;
      const cacheAndSet = (payload: any, mode: 'set' | 'update' = 'set') => {
        const limited = limitTagsForUi(payload);
        if (cacheKey && limited) {
          processedCategoryCacheRef.current.set(cacheKey, cloneTagsPayload(limited));
        }
        const isStale =
          cacheKey &&
          currentCategoryRef.current &&
          cacheKey !== currentCategoryRef.current &&
          loadType === LOAD_TYPE.tagsSearchIntoCategory;
        if (isStale) {
          return;
        }
        if (mode === 'set') {
          dispatch(TagsActions.setTags(limited));
        } else {
          dispatch(TagsActions.updateTags(limited));
        }
      };

      if (loadType === LOAD_TYPE.initial || loadType === LOAD_TYPE.tagSearchGlobal) {
        cacheAndSet(groupped, 'set');
        setIsLoading(false)
      }
      if ((loadType === LOAD_TYPE.tagSearch || loadType === LOAD_TYPE.update) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.tagsSearchIntoCategory && groupped?.length >= 1) {
        cacheAndSet(groupped, 'set');
      }
      if (loadType === LOAD_TYPE.tagSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.tagGlobalSearchIntoTag && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getUpdated(tagsList, groupped)))
      }
      if ((loadType === LOAD_TYPE.tagsFetchMore || loadType === LOAD_TYPE.test) && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.tagsFetchMoreLarge && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped, LOAD_TYPE.tagsFetchMoreLarge)))
      }
      if (loadType === LOAD_TYPE.tagsFetchMoreLargeChild && groupped?.length === 1) {
        dispatch(TagsActions.updateTags(getSearched(tagsList, groupped)))
      }
      if (loadType === LOAD_TYPE.updateLang) {
        setLoadType(LOAD_TYPE.initial);
      }
    }
  }, [groupped, load, loadType, dispatch, i18n.language, tagsFilter?.groupIds, limitTagsForUi, cloneTagsPayload])

  useEffect(() => {
    if (mainSearchRef) {
      mainSearchRef.current?.focus()
    }
  }, [mainSearchRef])


  useEffect(() => {
    if (innerValue && !!innerValue.length && mode === 'link') {
      onModalClose(innerValue[0])
    }
  }, [innerValue, onModalClose, mode])

  const onToggleActiveTag = useCallback((id: string | null) => {
    if (activeTag.current === id) {
      activeTag.current = null;
    } else {
      activeTag.current = id;
    }
  }, []);

  const handleApplySearchText = useCallback((e: any) => {
    const str = e.target.value.trim();
    if (str && str.length > 1) {
      const { hasEduTags, ...filteredInitialTagsFilter } = initialTagsFilter;
      setTagsFilter({
        search: [e.target.value],
        ...filteredInitialTagsFilter,
        ...(!!isViewAllTagsMode ? {} : {
          groupIds: [],
          ...(hasEduTags !== undefined ? {isEducation: undefined} : {}),
        })
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
      setSearchText(str)
      setTime(Date.now())
    }
    if (str === '') {
      setInitialSearchParam(null)
      setTagsFilter({
        ...initialTagsFilter,
      })
      setSearchText('')
      onToggleActiveTag(null)
      setLoadType(LOAD_TYPE.initial)
      setTime(Date.now())
    }
  }, [initialTagsFilter, isViewAllTagsMode, onToggleActiveTag, setTagsFilter]);

  const debouncedApplySearchText = useMemo(
    () => debounceEvent(handleApplySearchText, 1000),
    [handleApplySearchText],
  );

  const handleSearchInputChange = useCallback((e: any) => {
    setSearchInputValue(e.target.value);
    debouncedApplySearchText(e);
  }, [debouncedApplySearchText]);

  const handleClearSearchClick = useCallback(() => {
    setSearchInputValue('');
    if (mainSearchRef?.current) {
      mainSearchRef.current.value = '';
      mainSearchRef.current.focus?.();
    }
    handleApplySearchText({ target: { value: '' } });
  }, [handleApplySearchText]);

  const handleSearchIntoTagChange = useCallback((e: any, id: string, loadT?: number) => {
    const isCategorySearch = loadT && [LOAD_TYPE.tagsSearchIntoCategory].includes(loadT);
    const isGlobalSearchIntoTag = loadT && [LOAD_TYPE.tagGlobalSearchIntoTag, LOAD_TYPE.tagSearchIntoTag].includes(loadT);
    const entityFilter = !isGlobalSearchIntoTag && { isHeaderIgnored: !!searchText }

    const str = e.target.value.trim();

    if ((str && str.length > 0) || (!isCategorySearch && !isGlobalSearchIntoTag)) {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;
      setTagsFilter({
        groupIds: [id],
        search: [str],
        status: [0],
        isHeaderIgnored: true,
        ...filteredOptionTagsFilter,
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    if (str === '' && isCategorySearch) {
      setTagsFilter({
        ...initialTagsFilter,
        groupIds: [id],
        ...(isCreateLocation ? { entityTypes: [] } : {})
      })
      setLoadType(LOAD_TYPE.initial)
    }

    if (str === '' && isGlobalSearchIntoTag) {
      setTagsFilter({
        ...entityFilter,
        ...optionTagsFilter,
        status: [0],
        isHeaderIgnored: true,
      })

      setLoadType(loadT || LOAD_TYPE.tagSearch)
    }

    setTime(Date.now())

  }, [initialTagsFilter, optionTagsFilter, isCreateLocation])


  const applyCategoryFilter = useCallback((tagId: string) => {
    if (currentCategoryRef.current !== tagId) {
      return;
    }

    if (tagId === 'all') {
      const { hasEduTags, ...filteredOptionTagsFilter } = optionTagsFilter;

      setTagsFilter({
        search: searchText ? [searchText] : [],
        status: [0],
        isHeaderIgnored: global,
        groupIds: [],
        ...filteredOptionTagsFilter,
        ...(hasEduTags !== undefined ? {isEducation: undefined} : {})
      })
      setLoadType(LOAD_TYPE.tagSearchGlobal)
      return;
    }

    setTagsFilter({
      groupIds: [tagId],
      status: [0],
      isHeaderIgnored: global,
      ...optionTagsFilter
    })
    setLoadType(LOAD_TYPE.tagsSearchIntoCategory)
  }, [setTagsFilter, searchText, optionTagsFilter, global])

  const categoryHoverTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleCategoryHover = useCallback((tagId: string) => {
    if (categoriesOnly) {
      return;
    }

    if (tagId === currentCategory) {
      return;
    }

    currentCategoryRef.current = tagId;
    setCurrentCategory(tagId);

    if (categoryHoverTimerRef.current) {
      clearTimeout(categoryHoverTimerRef.current);
      categoryHoverTimerRef.current = null;
    }

    const cached = processedCategoryCacheRef.current.get(tagId);
    if (cached) {
      startTransition(() => {
        dispatch(TagsActions.setTags(cloneTagsPayload(cached)));
      });
      setLoadType(LOAD_TYPE.tagsSearchIntoCategory);
      return;
    }

    categoryHoverTimerRef.current = setTimeout(() => {
      categoryHoverTimerRef.current = null;
      applyCategoryFilter(tagId);
    }, 250);
  }, [categoriesOnly, currentCategory, applyCategoryFilter, dispatch, cloneTagsPayload])

  useEffect(() => {
    tagSearchListRef.current?.scrollTo(0, 0);
  }, [currentCategory])

  const handleToggleChildrenClick = useCallback((id: string) => {
    const changed = tagsList.map((c) => {
      const iend = c?.childrens?.filter((k: Tag) => k?.tagId === id)[0];

      if (iend && iend?.level === 1 && iend?.additionalTags?.length === 0) {
        setTagsFilter({
          groupIds: [iend?.tagId],
          status: [0],
          ...optionTagsFilter,
        })
        setLoadType(LOAD_TYPE.update)
        setTime(Date.now())
      }
      
      return c;
    })

    dispatch(TagsActions.setTags(changed))
    onToggleActiveTag(id)
  }, [tagsList, dispatch, optionTagsFilter])

  const handleSetUrlClick = useCallback((id: string): void => {
    if (id) {
      if (isLaboratoryPage) {
        history.push(CreateLinkTo.tag(id + `/${LABORATORY_PARAM}&${APPROVED_HSEDESIGN_PARAM.slice(1)}`))
      } else if (isHSEdesign) {
        history.push(CreateLinkTo.tag(id + '/' + APPROVED_HSEDESIGN_PARAM))
      } else {
        history.push(CreateLinkTo.tag(id))
      }
      modal.hide();
    }
  }, [isLaboratoryPage, isHSEdesign, history, modal])

  const handleMoreClick = useCallback((id: string, loadT?: number) => {
    setTagsFilter({
      groupIds: [id],
      status: [0],
      isHeaderIgnored: true,
      ...optionTagsFilter
    })

    setTime(Date.now())
    setLoadType(loadT || LOAD_TYPE.update)
  }, [])

  const foundTagsRef = useRef<HTMLDivElement>(null);
  const [resultTagsHeight, setResultTagsHeight] = useState(is992 ? 170 : 380);

  const graveStyle = {
      fontFamily: 'Inter',
      fontWeight: 400,
      padding: '2px 8px 4px 8px', 
      fontSize: '11px', 
      lineHeight: '13px', 
      letterSpacing: '-0.02em',
      color: '#fff',
      backgroundColor: '#2C2C2B',
      background: '#2C2C2B',
      textColor: '#fff',
      id: 'tooltip-parent-element',
      className: 'tooltip-parent-element',
    }
    const tooltipStyles = (!isCGRAVE && !isContinuumSite) ? getTooltipStyles(theme) : graveStyle

  const currentCategoryName = useMemo(() => {
    return categoryList?.find((c) => c?.tagId === currentCategory)?.name || ''
  }, [categoryList, currentCategory])

  const selectedCategoryIds = useMemo(
    () => innerValue.filter((v: any) => v?.isTagCategory).map((v: any) => v.tagId),
    [innerValue],
  )

  const handleCategoryClick = useCallback((tag: any) => {
    if (!allowCategorySelect || !tag?.tagId) return;
    const alreadySelected = innerValue.some((v: any) => v?.tagId === tag.tagId && v?.isTagCategory);
    if (alreadySelected) {
      setInnerValue(innerValue.filter((v: any) => v?.tagId !== tag.tagId));
    } else {
      setInnerValue([...innerValue, { ...tag, isTagCategory: true }]);
    }
  }, [allowCategorySelect, innerValue, setInnerValue])

  useEffect(() => {

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setResultTagsHeight(entry.target.getBoundingClientRect().height + (isLinkMode ? (is992 ? 200 : 250) : (is992 ? 144 : 353)))
      }
    })

    if (foundTagsRef?.current) {
      resizeObserver.observe(foundTagsRef?.current)
    }

    return () => {
      if (foundTagsRef?.current) {
        resizeObserver.unobserve(foundTagsRef?.current)
      }
    }
  }, [is992])

  if (isCreateMode) {
    return (
      <CreateTagComponent 
        onClose={() => setIsCreateMode(false)} 
        onCreateTag={onAfterTagCreate} 
      />
    )
  }

  return (
    <TagsSearchModalWrapper>
      {!isLinkMode && !is992 && (
        <LangSelectHolder>
          <LangSwitcher
            currentLanguage={i18n.language}
            onLangSelect={onLangSelect}
            key="lang"
          />
        </LangSelectHolder>
      )}
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {!isLinkMode && saveOnClick && (
          <TitleContainer>
            <TagsSearchTitle color={theme.tagSearch.titleColor}>
              {t(mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
            </TagsSearchTitle>
            <SubmitButton variant={ButtonVariant.Filled} className='select-tags-modal--save-button' onClick={onSaveTagsByClick}>{t('save_tag')}</SubmitButton>
          </TitleContainer>
        )}
        {!isLinkMode && !saveOnClick && (
          <TagsSearchTitle color={theme.tagSearch.titleColor}>
            {t(isTagEditor ? 'tag_editor' : mode === 'link' ? 'select_single' : requiredTags ? 'select_required' : 'select')}
          </TagsSearchTitle>
        )}
        {!hideGlobalSearchBar && !(isHseSpace && isCompetencies) && (
          <TagsSearchInputWrapper
            isCGRAVE={isCGRAVE || isContinuumSite}
            offsetTop={(is992 && isMobileMenu) ? 20 : isLinkMode ? 0 : (is992 ? 16 : 48)}
            isMobileMenu={is992 && isMobileMenu}
            gx={12}
          >
            <SearchIcon fill={theme.tags.modal.search.color}/>
            <TagsSearchInput
              ref={mainSearchRef}
              value={searchInputValue}
              onChange={handleSearchInputChange}
              placeholder={t('tags_modal.search_mobile')}
            />
            {searchInputValue.length > 0 && (
              <ClearSearchButton type="button" onClick={handleClearSearchClick} aria-label="Clear search">
                <ClearSearchIcon />
              </ClearSearchButton>
            )}
          </TagsSearchInputWrapper>
        )}
        {(!isMobile && !isGlobalEmptySearch) && (
          <TagsSearchSelection
            ref={foundTagsRef}
            style={{
              display: 'flex',
              flexFlow: 'row',
              margin: '0',
              paddingTop: innerValue.length > 0 ? '24px' : '8px',
              paddingBottom: innerValue.length > 0 ? '14px' : 0,
            }}>
            {!isLinkMode && !!innerValue.length && (
              <TagsSelectedTitle
                style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
              >
                {(!!innerValue.length && mode !== 'link') ? (isTagEditor ? `${t('tags_in_project')}:` : `${t('tags_modal.selected_tags')}:`) : t('tags_modal.select_tags')}
              </TagsSelectedTitle>
            )}
            {
              !!innerLocalValue.length && (
                <BTagsGridNew className='selected-tags-grid'>
                  {mode !== 'link' &&
                  innerLocalValue.map((v: any) => (
                    <BTag
                      tag={v}
                      removable={true}
                      key={v.tagId}
                      educational={isRequired(v)}
                      organization={v?.isTeamTag}
                      showRemoveIcon={!(isTagEditor && !editableTags.includes(v.tagId) && !isModer)}
                      disabled={!!isTagEditor && !editableTags.includes(v.tagId) && !isModer}
                      onIconClick={() => {
                        if (isTagEditor && !editableTags.includes(v.tagId) && !isModer) {
                            return;
                        }
                        if (protectedTags.includes(v.tagId)) {
                          toasts.error('Это обязательный тег');
                        } else {
                          const vi = innerValue.filter((t) => t.tagId !== v.tagId);
                          ReactTooltip.hide()
                          setInnerValue(vi);
                        }
                      }}
                    >
                      {bTag.title(v)}
                    </BTag>
                  ))}
                </BTagsGridNew>
              )}
          </TagsSearchSelection>
        )}
          {isTagEditor &&
              <TagsAvailableTitle
              style={{ display: 'inline-flex', placeItems: 'center', whiteSpace: 'nowrap' }}
          >
            {t('available_tags_in_project')}
          </TagsAvailableTitle>}
        <TagsSearchResultsWrapper
            direction={isViewAllTagsMode ? 'column' : 'row'}
            gx={is992 ? 16 : 24}
            offsetTop={!!innerValue?.length ? 16 : 22}
            shadowColor={theme.app.backgroundColor}
        >
          {isGlobalEmptySearch && !isLoading && (
            <EmptyTextWrapper direction="column" gy={24} isIqMediia={isIqMediia} width="100%" align="center" justify="center">
              <EmptyText>{t("tags_modal.empty_search_select_from_list")}</EmptyText>
              {(isTagAdminPage || viewAllTags) && <BrgButton variant={ButtonVariant.Filled} onClick={() => setIsCreateMode(true)}>{t("tags_modal.create_tag")}</BrgButton>}
            </EmptyTextWrapper>
          )}
          {categoryVisible && !isGlobalEmptySearch && (
              <>
                <CategoryList
                    tags={categoryList}
                    onHover={handleCategoryHover}
                    currentCategory={currentCategory}
                    customHeight={is992 ? 330 : resultTagsHeight}
                    isClickable={isLinkMode}
                    fullWidth={categoriesOnly}
                    setHideMore={setHideMore}
                    onCategoryClick={allowCategorySelect ? handleCategoryClick : undefined}
                    selectedCategoryIds={selectedCategoryIds}
                />
                {is992 && <ModalContextSplitLine/>}
              </>
          )}
          {isLoading && (
            <FlexBox justify="center" width='100%' style={{ height: resultTagsHeight }}>
              <LoaderSpinner color={theme.selectContextModal.loaderText} text={t('project_edit.modal.load_msg_tag')}/>
            </FlexBox>
          )}
          {!categoriesOnly && !isLoading && (
            <TagsSearchResults
              customHeight={resultTagsHeight}
              direction={'column'}
              directionMobile={"column"}
              width={'100%'}
              ref={tagSearchListRef}
            >
              <TagsSearchResultsContext
                  direction={'column'}
                  directionMobile={'column'}
                  width={'100%'}
                  isGlobalSearch={isGlobalSearch}
              >
                <BTagsGridNew
                    style={{
                      position: 'relative',
                      height: 'auto',
                      paddingBottom: '10px'
                    }}
                    noLimitMaxHeight
                >
                  {<TabletTitle
                      onClick={() => {
                        if (!is992) return;
                        history.push(CreateLinkTo.tag(currentCategory || ''));
                      }}
                      width='100%'
                      gx={8}
                      offsetBottom={is992 ? 14 : 4}
                      align="center">
                        <span>{currentCategoryName}</span>
                        {is992 && <ArrowTopRightIcon/>}
                  </TabletTitle>}
                  {searchedItems
                    .map((g: any) => {
                      const items = isViewAllTagsMode ? g?.tags : g?.childrens;
                      return (
                        <TagsSearchResultsItem
                          hideMore={hideMore}
                          setHideMore={setHideMore}
                          isViewAllTagsMode={viewAllTags}
                          search={searchText}
                          key={g?.categoryId}
                          activeTagId={activeTag.current || ''}
                          title={g?.categoryTitle}
                          identifier={g?.categoryId}
                          items={items}
                          found={g?.found}
                          isCategorySearchNeed={g?.isSearchButton}
                          searchingIntoTag={isLocalSearch}
                          isSelected={(id) => innerValue.some((v) => v?.tagId === id)}
                          isCategoryTag={g?.isTagCategory}
                          onClick={(tag: any, selected) => {
                            let v = innerValue;
                            if (!selected) {
                              const educationalTags = innerValue.filter(({ isEducationTag }: any) => isEducationTag);

                              if (mode === 'link' || max === 1) {
                                v = [tag];
                              } else if (maxEducationalTags === 1 && tag?.isEducationTag && educationalTags.length >= 1) {
                                v = [...innerValue.filter((t) => !t.isEducationTag), tag];
                              } else if (maxEducationalTags !== undefined && tag?.isEducationTag && educationalTags?.length + 1 > maxEducationalTags) {
                                toasts.error(maxEducationalTags > 1
                                  ? t('project_edit.max_education_tags_error', { count: maxEducationalTags })
                                  : t('project_edit.max_required_tags_error'))
                              } else if (max && innerValue?.length + 1 > max) {
                                toasts.error(
                                  maxTagsExceededMessageKey
                                    ? t(maxTagsExceededMessageKey)
                                    : t('project_edit.select_tags_max_error', { count: max }),
                                );
                                v = innerValue;
                              } else {
                                v = [...innerValue, tag];
                              }
                            } else if (protectedTags.includes(tag?.tagId)) {
                              toasts.error('Это обязательный тег');
                              return;
                            } else {
                              v = innerValue.filter((t) => t.tagId !== tag.tagId);
                            }
                            setInnerValue(v);
                          }}
                          onTagArrowClick={handleToggleChildrenClick}
                          onParentClick={handleSetUrlClick}
                          onMoreClick={handleMoreClick}
                          onSearchInputChange={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          onSearchIntoCategory={(e) => handleSearchIntoTagChange(e, g?.categoryId, LOAD_TYPE.tagsSearchIntoCategory)}
                          setIsOpenTag={setIsOpenTag}
                          isEditPage={isEdit || isCreateLocationPage}
                          loadType={loadType}
                          isEmptySearch={isEmptySearchForAddintTags}
                          tagsFilter={tagsFilter}
                          setTime={setTime}
                          isGlobalSearch={isGlobalSearch}
                          isShowAll={g.isShowAll}
                          isLinkMode={isLinkMode}
                          isCreateLocationPage={isCreateLocationPage}
                        />
                      );
                    })}
                  <ReactTooltip  {...tooltipStyles}/>
                </BTagsGridNew>
              </TagsSearchResultsContext>
              {isViewAllTagsMode && (
                <SimplePagination 
                  page={Number(page || 1)} 
                  pages={
                    fetchedAllTags.length >= ALL_TAGS_LIMIT
                      ? Number(page || 1) + 1
                      : Math.max(1, Number(page || 1))
                  } 
                  onPageChange={handlePageChange} 
                  disableOffset
                />
              )}
            </TagsSearchResults>
          )}
        </TagsSearchResultsWrapper>
      </TagsSearchModalContainer>
      <ReactTooltip/>
    </TagsSearchModalWrapper>
  );
};
